import React from 'react';
import { PathMatch, PathPattern } from 'react-router';
import { useParams, useNavigate, useLocation, Location, NavigateFunction, matchPath } from 'react-router-dom';

export interface WithRouterProps<RP extends Record<string, string> = {}> {
    routeParams: RP;
    navigate: NavigateFunction;
    matchPath<Path extends string>(pattern: PathPattern | Path, pathname: string): PathMatch | null;
    location: Location;
}

export function withRouter<P, RP extends Record<string, string>>(
    Component: React.ComponentType<P & WithRouterProps<RP>>,
): React.ComponentType<P> {
    return (props: P) =>
        React.createElement(Component, {
            ...props,
            matchPath,
            routeParams: useParams<RP>() as RP,
            navigate: useNavigate(),
            location: useLocation(),
        });
}
